import { Phone, Mail, MapPin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-black border-t border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-3 gap-8">
          {/* Company Info */}
          <div>
            <img 
              src="https://static.wixstatic.com/media/f1e95d_bd3da2d723c5414bbf05fd6cc2f28086~mv2.png" 
              alt="YYC Pick-Up: Delivery & Hauling Services" 
              className="h-28 w-auto mb-4"
            />
            <p className="text-gray-400 mb-4">
              Calgary's premier delivery and hauling service. Locally owned, fully insured, and committed to excellence.
            </p>
            <p className="text-sm text-gray-500">
              Serving Calgary and surrounding areas
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-[#d4af37]">Our Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li>• Junk Removal</li>
              <li>• Deliveries</li>
              <li>• Small to Medium Size Moving</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold text-lg mb-4 text-[#d4af37]">Contact Us</h4>
            <div className="space-y-3 text-gray-400">
              <a href="tel:4038014638" className="flex items-center hover:text-[#d4af37] transition">
                <Phone className="w-4 h-4 mr-2" />
                (403) 801-4638
              </a>
              <a href="mailto:yychauling@gmail.com" className="flex items-center hover:text-[#d4af37] transition">
                <Mail className="w-4 h-4 mr-2" />
                yychauling@gmail.com
              </a>
              <div className="flex items-center">
                <MapPin className="w-4 h-4 mr-2" />
                Calgary, AB
              </div>
            </div>
            
            <div className="mt-6">
              <p className="text-sm text-gray-400 mb-2">Follow Us</p>
              <div className="flex space-x-4">
                <a href="https://www.facebook.com/61575534194820" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-[#d4af37] transition">
                  <Facebook className="w-6 h-6" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            &copy; {currentYear} YYC Pick-Up: Delivery & Hauling Services Ltd. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs mt-2">
            Registered and Insured | Locally Owned and Operated
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;